module.exports = __webpack_public_path__ + "static/media/admIconColored.f3ea4816.svg";